import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-mws-reporting-identity',
  templateUrl: './help-mws-reporting-identity.component.html'
})
export class HelpMwsReportingIdentityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
